/*
 * @Author: zhaoyu zhaoy@normstar.com
 * @Date: 2024-03-29 11:48:54
 * @LastEditors: zhaoyu zhaoy@normstar.com
 * @LastEditTime: 2024-08-21 20:27:34
 * @FilePath: \ns-web-evaluation\pc\src\ehome\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { inEHomeApp } from '@/utils/ehome'
export async function setUpEHome() {
  const styleHandle = () => {
    const rootEle = document.querySelector('body') as HTMLElement
    rootEle.classList.add('nhEhome')
  }

  // ehome交互文件加载
  const router = useRouter()
  const route = useRoute()

  // ehome返回原生事件
  const backHandler = () => {
    if (route.name === 'evaluation') {
      window.location.href = 'cube://exit'
    } else {
      router.back()
    }
  }

  if (inEHomeApp()) {
    console.log('ehomeapp init')
    styleHandle()
    // await new Promise((resove) => {
    //   document.addEventListener(
    //     'deviceready',
    //     // 'click',
    //     () => {
    //       resove('cordova加载完成')
    //     },
    //     false
    //   )
    // }) // 发布E家上面，确定加载cordova
    document.addEventListener('backbutton', backHandler, false) // 如果没有特殊界面跳转需求可以屏蔽
  } else {
    styleHandle()
  }
}
